import { render, staticRenderFns } from "./DetalleGridParada.vue?vue&type=template&id=61acbd7a&scoped=true"
import script from "./DetalleGridParada.vue?vue&type=script&lang=js"
export * from "./DetalleGridParada.vue?vue&type=script&lang=js"
import style0 from "./DetalleGridParada.vue?vue&type=style&index=0&id=61acbd7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61acbd7a",
  null
  
)

export default component.exports